var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.SidebarToggle,
    {
      staticClass: "d-flex h-100 overflow-auto",
      attrs: { name: "site_tree" },
      scopedSlots: _vm._u([
        {
          key: "leftSidebar",
          fn: function () {
            return [
              _c(
                "div",
                { staticClass: "flex-grow-1" },
                [
                  _c(
                    "div",
                    { staticClass: "text-center" },
                    [
                      _c(_setup.SiteTreeNavigationMenu, {
                        staticClass: "m-3 d-inline-block",
                        attrs: { "site-tree-id": _setup.siteTreeId },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(_setup.SiteTree, {
                    attrs: { "site-tree-id": _setup.siteTreeId },
                  }),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm._v(" "),
      _c(
        "section",
        { staticClass: "d-flex h-100 overflow-auto flex-grow-1 flex-column" },
        [
          _setup.formId
            ? _c(_setup.FormHeader, {
                key: "header-" + _setup.formId,
                attrs: {
                  "form-id": _setup.formId,
                  "show-add-btn": true,
                  "show-save-and-close-btn": _setup.showSaveAndCloseBtn,
                  "show-save-btn": true,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _setup.formId
            ? _c(_setup.FormNavAndForm, {
                key: "body-" + _setup.formId,
                attrs: {
                  "form-id": _setup.formId,
                  "show-archive-btn": true,
                  "show-duplicate-btn": true,
                  "show-history-btn": true,
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }